import react from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import '../../styles/mobidawg-style.scss'



function Community() {
    return(
        <div>
            <Typography variant="h6" gutterBottom>
            Community
            </Typography>
            <Typography variant="body1" gutterBottom>
                Community is important ...
            </Typography>
        </div>
    )
}

export default Community;
